import { get } from "../helpers/apihelpers";

export const GetHomeDataService=async(department)=>{
    try {
        const result = await get(`api/home_data/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}